module.exports = __webpack_public_path__ + "static/media/app-store-image.729235d0.png";